import MaterialIcon from '@/components/atom/MaterialIcon';

interface Props {
  navigateDietInjectionScreen: () => void;
}

const DietInjectionFeatureSnippet = ({ navigateDietInjectionScreen }: Props) => {
  return (
    <div className={'flex justify-between gap-[16px] py-[16px]'} onClick={navigateDietInjectionScreen}>
      <div className={'flex items-center gap-[16px]'}>
        <img
          alt={'dietInjectionSnippetIcon'}
          src={'/images/search/dietInjectionSnippetIcon.png'}
          className={'h-[40px] w-[40px]'}
        />
        <div className={'flex flex-col gap-[2px]'}>
          <span className={'typography-ui-17sb text-gray-600'}>다이어트 주사 받기</span>
          <span className={'typography-ui-13r text-gray-400'}>진료비, 약 값 비교부터 예약까지 한 번에</span>
        </div>
      </div>
      <MaterialIcon name={'keyboard_arrow_right'} />
    </div>
  );
};

export default DietInjectionFeatureSnippet;
